<div
  class="flex max-h-[80vh] w-[900px] flex-col rounded-[28px] border-2 border-background-white bg-background-modal p-6 shadow-modal backdrop-blur-2xl"
>
  <!-- Header -->
  <div class="mb-6 flex items-center justify-between">
    <h2 class="text-xl font-semibold">Perio Exam Recordings</h2>
    <button (click)="onClose()" class="hover:bg-gray-100 flex h-8 w-8 items-center justify-center rounded-full">
      <svg-icon key="px-24-x" size="md"></svg-icon>
    </button>
  </div>

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="flex items-center justify-center py-12">
      <div class="text-center">
        <div class="border-primary mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2"></div>
        <p class="text-gray-600">Loading recordings...</p>
      </div>
    </div>
  }

  <!-- Error State -->
  @if (errorMessage() && !isLoading()) {
    <div class="flex items-center justify-center py-12">
      <div class="text-red-600 text-center">
        <svg-icon key="px-24-warning" size="lg" class="mb-4"></svg-icon>
        <p>{{ errorMessage() }}</p>
      </div>
    </div>
  }

  <!-- Recordings List -->
  @if (!isLoading() && !errorMessage() && recordings()) {
    @if (recordings()!.length === 0) {
      <div class="flex items-center justify-center py-12">
        <div class="text-gray-500 text-center">
          <svg-icon key="px-24-audio" size="lg" class="mb-4"></svg-icon>
          <p>No recordings found for this patient</p>
        </div>
      </div>
    } @else {
      <div class="flex-1 space-y-3 overflow-y-auto">
        @for (recording of recordings(); track recording.recordingId) {
          <div class="bg-white border-gray-200 flex flex-col gap-3 rounded-lg border p-4">
            <!-- Recording Header -->
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg-icon key="px-24-audio" size="sm"></svg-icon>
                <span class="font-medium">{{ formatDate(recording.uploadDate) }}</span>
              </div>
              <div class="flex items-center gap-2">
                @if (recording.logText) {
                  <button
                    (click)="onShowLogs(recording.recordingId)"
                    class="hover:bg-gray-100 text-sm flex items-center gap-1 rounded-lg px-3 py-1.5 transition-colors"
                    title="Show logs"
                  >
                    <svg-icon key="px-24-info" size="sm"></svg-icon>
                  </button>
                }
                @if (recording.audioUrl) {
                  <button
                    (click)="onDownload(recording)"
                    class="hover:bg-gray-100 text-sm flex items-center gap-1 rounded-lg px-3 py-1.5 transition-colors"
                    title="Download"
                  >
                    <svg-icon key="px-24-download" size="sm"></svg-icon>
                  </button>
                }
                <button
                  (click)="onDelete(recording.recordingId)"
                  [disabled]="service.isDeleting(recording.recordingId)"
                  class="hover:bg-red-50 hover:text-red-600 text-sm flex items-center gap-1 rounded-lg px-3 py-1.5 transition-colors disabled:opacity-50"
                  title="Delete"
                >
                  @if (service.isDeleting(recording.recordingId)) {
                    <div class="border-gray-400 h-4 w-4 animate-spin rounded-full border-2 border-t-transparent"></div>
                  } @else {
                    <svg-icon key="px-24-x-circle" size="sm"></svg-icon>
                  }
                </button>
              </div>
            </div>

            <!-- Audio Player -->
            @if (recording.audioUrl) {
              <audio controls class="w-full">
                <source [src]="recording.audioUrl" type="audio/wav" />
                <source [src]="recording.audioUrl" type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            } @else {
              <div class="text-sm text-gray-400 italic">No audio available</div>
            }
          </div>
        }
      </div>
    }
  }

  <!-- Logs Overlay -->
  @if (showLogsOverlay()) {
    <div class="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50" (click)="onCloseLogsOverlay()">
      <div class="max-h-[80vh] w-[700px] overflow-hidden rounded-lg bg-text-white shadow-2xl" (click)="$event.stopPropagation()">
        <div class="bg-white border-gray-200 flex items-center justify-between border-b p-4">
          <h3 class="text-lg font-semibold">Logs</h3>
          <button (click)="onCloseLogsOverlay()" class="hover:bg-gray-100 flex h-8 w-8 items-center justify-center rounded-full">
            <svg-icon key="px-24-x" size="md"></svg-icon>
          </button>
        </div>
        <div class="bg-gray-50 max-h-[calc(80vh-80px)] overflow-y-auto p-4">
          <pre class="bg-white text-gray-800 font-mono text-sm whitespace-pre-wrap rounded p-4">{{ showLogsOverlay()!.logText }}</pre>
        </div>
      </div>
    </div>
  }
</div>
